import React from 'react'
import './SearchBarStyle.css';

const SearchBar = ({ placeholder, className, value, onChange, onKeyDown, onClick }) => {
  return (
    <label htmlFor="search" className={`SearchBox flexbox ${className}`}>
      <svg className='pointer' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} >
        <path d="M7.66671 14C11.1645 14 14 11.1645 14 7.66667C14 4.16886 11.1645 1.33333 7.66671 1.33333C4.1689 1.33333 1.33337 4.16886 1.33337 7.66667C1.33337 11.1645 4.1689 14 7.66671 14Z" stroke="#525252" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.6667 14.6667L13.3334 13.3333" stroke="#525252" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <input type='text' placeholder={placeholder} id='search' value={value} onChange={onChange} onKeyDown={onKeyDown} />
    </label>
  )
}

export default SearchBar